@if (show) {
  <div class="overlay-spinner" [ngClass]="[type, customBg]">
    <nz-spin nzSimple nzSize="large"></nz-spin>
  </div>
}
